import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import useManagement, { selectors } from 'client/hooks/useManagement'
import { pageSelectors, usePage } from 'client/store'
import {
  TwoStepPaymentFormContent,
  TwoStepPaymentFormForm,
  TwoStepPaymentFormHeader,
  TwoStepPaymentFormHeaderItem,
} from 'common/components/entities/two-step-payment-form'
import { PaymentFormStepTypeEnum } from 'common/enums/PaymentFormStepTypeEnum'
import { TwoStepPaymentFormInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'
import { TwoStepPaymentFormOptInStep } from './two-step-payment-form-opt-in-step'
import { TwoStepPaymentFormPaymentStep } from './two-step-payment-form-payment-step'

export interface TwoStepPaymentFormProps {
  entity: TwoStepPaymentFormInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export const TwoStepPaymentForm = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: TwoStepPaymentFormProps) => {
  const stepType = useManagement(selectors.getTwoStepPaymentFormStepType)
  const isPaymentStep = stepType === PaymentFormStepTypeEnum.STEP_PAYMENT
  const isOptInStep = stepType === PaymentFormStepTypeEnum.STEP_OPT_IN
  const stepOptInEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[0]),
  )
  const stepPaymentEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[1]),
  )

  if (!stepOptInEntity || !stepPaymentEntity) {
    return null
  }

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <TwoStepPaymentFormForm
        id={entity.htmlAttrId}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
      >
        <TwoStepPaymentFormHeader>
          <TwoStepPaymentFormHeaderItem
            number={1}
            backgroundColor={entity.headerBackgroundColor}
            mobileBackgroundColor={entity.mobileHeaderBackgroundColor}
            color={entity.headerTextColor}
            mobileColor={entity.mobileHeaderTextColor}
            headerUnderlineColor={entity.headerUnderlineColor}
            headline={stepOptInEntity.headline}
            subHeadline={stepOptInEntity.subHeadline}
            active={isOptInStep}
          />
          <TwoStepPaymentFormHeaderItem
            number={2}
            backgroundColor={entity.headerBackgroundColor}
            mobileBackgroundColor={entity.mobileHeaderBackgroundColor}
            color={entity.headerTextColor}
            mobileColor={entity.mobileHeaderTextColor}
            headerUnderlineColor={entity.headerUnderlineColor}
            headline={stepPaymentEntity.headline}
            subHeadline={stepPaymentEntity.subHeadline}
            active={isPaymentStep}
          />
        </TwoStepPaymentFormHeader>
        <TwoStepPaymentFormContent
          padding={entity.padding}
          mobilePadding={entity.mobilePadding}
          backgroundColor={entity.backgroundColor}
          mobileBackgroundColor={entity.mobileBackgroundColor}
        >
          {isOptInStep && (
            <TwoStepPaymentFormOptInStep
              entity={stepOptInEntity}
              color={entity.buttonTextColor}
              mobileColor={entity.mobileButtonTextColor}
              backgroundColor={entity.buttonBackgroundColor}
              mobileBackgroundColor={entity.mobileButtonBackgroundColor}
            />
          )}
          {isPaymentStep && (
            <TwoStepPaymentFormPaymentStep
              entity={stepPaymentEntity}
              color={entity.buttonTextColor}
              mobileColor={entity.mobileButtonTextColor}
              backgroundColor={entity.buttonBackgroundColor}
              mobileBackgroundColor={entity.mobileButtonBackgroundColor}
              paypal={entity?.paypal}
            />
          )}
        </TwoStepPaymentFormContent>
      </TwoStepPaymentFormForm>
    </BaseEntityNew>
  )
}
